import UkFlag from "../../../assets/svg/regions/gb.svg";
import UsaFlag from "../../../assets/svg/regions/usa.svg";
import AusFlag from "../../../assets/svg/regions/aus.svg";
import { MessageContainer, Severity } from "../Message/MessageContainer";
import { LoadingPresentational } from "../Loading/LoadingPresentational";
import { Option, Dropdown, DropdownProps } from "@fluentui/react-components";
import { REGIONS, REGION_DISPLAY_ORDER, TRegion } from "../../models/region-model";

export interface Props {
  error: string | null;
  region: TRegion;
  signUpUrl: string;
  inProgress?: boolean;

  handleLogin: () => void;
  onRegionSelectionChanged: DropdownProps["onOptionSelect"];
}

const getRegionFlag = (code: string): string => {
  switch (code) {
    case REGIONS.AUS.code: {
      return AusFlag;
    }
    case REGIONS.USA.code: {
      return UsaFlag;
    }
    case REGIONS.GB.code: {
      return UkFlag;
    }
    default: {
      console.warn(`Invalid region code: ${code}. Defaulting to USA flag type.`);
      return UsaFlag;
    }
  }
};

export const AuthPresentational = (props: Props) => {
  const inProgress = props.inProgress === true;

  const message = inProgress
    ? "Please wait while we connect Word to Smokeball"
    : "Connect Word to Smokeball to save documents directly to a matter.";

  return (
    <>
      {(props.error && (
        <div className="flex flex-col mt-6 justify-center px-4">
          <MessageContainer title="Authentication Error" severity={Severity.Error} content={props.error} />
        </div>
      )) ??
        null}
      <div className="flex flex-col flex-1 mt-[120px]">
        <LoadingPresentational
          isLoading={inProgress}
          title="Word to Smokeball"
          severity={Severity.Information}
          onlyShowMessageIfIsLoading={false}
          message={message}
        />
        <div className="flex flex-col mt-8 justify-center px-4">
          <span className="mb-2 text-left text-sm font-semibold">Country</span>
          <Dropdown
            id="ddCountry"
            size="medium"
            placeholder="Select your region"
            onOptionSelect={props.onRegionSelectionChanged}
            value={props.region.name}
            defaultValue={props.region.name}
          >
            {REGION_DISPLAY_ORDER.map((region) => (
              <Option className="m-0 py-1 px-0" key={region.code} value={region.code} text={region.name}>
                <div className="flex flex-row">
                  <img className="align-middle" src={getRegionFlag(region.code)} alt={region.name} width="30" />
                  <span className="p-o ml-2.5 align-middle">{region.name}</span>
                </div>
              </Option>
            ))}
          </Dropdown>
        </div>
        <div className="flex flex-col flex-1 mt-8 justify-center px-4">
          <button
            className={`
        flex flex-row justify-center items-center h-10 border py-0 px-4 rounded-lg text-sm w-full border-primary-500 bg-primary-orange-500
        hover:border-primary-orange-400 hover:bg-primary-orange-400
        active:border-primary-orange-600 active:bg-primary-orange-600
        focus:outline-none focus:ring-2 focus:ring-primary-blue-560 focus:bg-primary-orange-400
            `}
            onClick={props.handleLogin}
          >
            <span className="text-white text-sm font-semibold">Connect to Smokeball</span>
          </button>
          <div className="flex justify-center items-center mt-2">
            Not a Smokeball client? Sign up
            <a
              className="hover:underline cursor-pointer ml-1 text-blue-500"
              target="_blank"
              rel="noreferrer"
              href={props.signUpUrl}
            >
              here
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
